import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";

interface courseMaterialsProps {
  courseMaterials: {
    all_hours: number;
    count_lecture: number;
    count_parts: number;
    parts: any[];
  };
}

export const CourseMaterialsPreview = React.memo(
  ({ courseMaterials }: courseMaterialsProps) => {
    const [expandedAccordion, setExpandedAccordion] = React.useState(
      courseMaterials && courseMaterials.parts.length > 0 ? 0 : false
    );
    const handleAccordionChange =
      (panel: number) =>
      (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
        setExpandedAccordion(isExpanded ? panel : false);
      };
    return (
      <Box>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 800,
            color: "#000",
            marginTop: "64px",
            marginBottom: "14px",
            "@media (max-width:1000px)": {
              marginTop: "20px",
            },
          }}>
          Материалы курса
        </Typography>
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: 400,
            marginBottom: "16px",
            color: "#808992",
          }}>{`${courseMaterials?.count_parts} разделов • ${courseMaterials?.count_lecture} лекций`}</Typography>
        {courseMaterials?.parts?.map((part: any, index: any) => (
          <Accordion
            key={index}
            expanded={expandedAccordion === index}
            onChange={handleAccordionChange(index)}
            sx={{
              boxShadow: "none",
              "&:before": {
                display: "none",
              },
              borderBottom: "1px solid rgba(1, 18, 36, 0.08)",
            }}>
            <AccordionSummary
              sx={{
                fontSize: "20px",
                fontWeight: 800,
              }}
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel-${index}-content`}
              id={`panel-${index}-header`}>
              {part.name}
            </AccordionSummary>
            <AccordionDetails
              sx={{
                fontSize: "18px",
                fontWeight: 400,
              }}>
              {part.description}
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    );
  }
);
